import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { components } from 'react-select';

export const CustomOption = ({
  innerRef,
  innerProps,
  isSelected,
  isFocused,
  children,
  ...props
}) => {
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={`custom-option ${
        isFocused ? 'is_focused' : ''
      } flex cursor-pointer justify-between py-3 px-6 focus:outline-none ${
        isSelected ? 'font-semibold' : 'font-normal'
      }`}
    >
      <p className="text-javelin-gray-dark">{children}</p>
      {isSelected ? (
        <FontAwesomeIcon
          icon="check-circle"
          className="text-brand-primary w-5 h-5 my-auto"
          size="2x"
        />
      ) : null}
    </div>
  );
};

export const ControlWithIcon = ({ children, ...props }) => {
  const { icon: Icon } = props.selectProps;

  return (
    <components.Control {...props}>
      <Icon className="text-gray-400 fill-current w-5 h-5" />
      {children}
    </components.Control>
  );
};

export const CustomValueContainer = ({
  children,
  innerRef,
  innerProps,
  ...props
}) => {
  const { name, email } = props.selectProps;
  return (
    <div ref={innerRef} {...innerProps} className="ml-2 w-40">
      <div>
        <span className="block font-bold text-javelin-gray-dark text-base">
          {name || ''} {children}
        </span>
        <span className="block text-javelin-blueGray w- text-sm overflow-ellipsis max-w-40 overflow-hidden">
          {email || ''}
        </span>
      </div>
    </div>
  );
};
export const OptionWithFlag = ({ children, ...props }) => {
  const code = props.data?.code?.toLowerCase();
  return (
    <components.Option {...props}>
      <div className="flex cursor-pointer items-center justify-start py-3 px-2 focus:outline-none">
        <span
          className={`w-6 h-6 lg:w-7 bg-no-repeat bg-center bg-contain flag-icon flag-icon-${code}`}
        ></span>
        <p className="text-sm ml-2">{`${props.data.name} ${props.data.dial_code}`}</p>
      </div>
    </components.Option>
  );
};

export const ValueWithFlag = ({ children, selectProps, ...props }) => {
  const code = selectProps.value?.code?.toLowerCase();
  return !!code ? (
    <components.SingleValue {...props}>
      <div className="flex cursor-pointer items-center justify-start py-3 px-2 focus:outline-none">
        <span
          className={`w-6 h-6 lg:w-7 bg-no-repeat bg-center bg-contain flag-icon flag-icon-${code}`}
        ></span>
        <p className="text-sm ml-2">{children}</p>
      </div>
    </components.SingleValue>
  ) : null;
};
